import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutAndPrincipal from "./components/AboutAndPrincipal";
import Mentors from "./components/Mentors";
import NoticeBoard from "./components/NoticeBoard";
import QuickLinks from "./components/QuickLinks";
import ImportantWebsites from "./components/ImportantWebsites";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <div className="app">
        <Header />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <AboutAndPrincipal />
                <Mentors />
                <NoticeBoard />
                <QuickLinks />
                <ImportantWebsites />
              </>
            }
          />
          {/* Add other routes for About, Contact, etc. */}
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
